import { Card } from "@mui/material";
import { useSelector } from "react-redux";
import { appdataSelector } from "reducers/appdata/appdata";

function VendordataNonEditablePart(props) {
  const appdata = useSelector(appdataSelector);
  const data = props.data;
  console.log("data", props.data);
  if (props.multi) {
    return (
      Object.keys(data).map(key => {

        let fields = data[key].item;

        let cls = "p-4 mt-2";
        if (data[key].DELETED) {
          cls += " bg-danger";
        }


        return (
          <Card key={"card" + key} className={cls}>
            <div className="row border-bottom mb-2 pb-2">
              <div className="col-2 d-none d-md-block">Label</div>
              <div className="col-6 col-md-5">New value</div>
              <div className="col-6 col-md-5">Original value</div>
            </div>

            {Object.keys(fields).map(fieldkey => {

              if (fields[fieldkey].hidden)
                return

              let highlightInfo = false;
              if (appdata.activeRequestType != "NV") {
                if (fields[fieldkey].active != fields[fieldkey].sap && (fields[fieldkey].active || fields[fieldkey].sap)) {
                  highlightInfo = true;
                }
              }


              return (
                <div className={(highlightInfo) ? "border border-info row mt-1 mb-1" : "row mt-1 mb-1"} key={"rowpart" + fieldkey}>
                  <div className="col-2 d-none d-md-block">
                    <b>{fields[fieldkey].label}</b>
                  </div>
                  <div className="col-6 col-md-5">{fields[fieldkey].active}</div>
                  <div className="col-6 col-md-5">{fields[fieldkey].sap}</div>
                </div>
              );
            })}

          </Card>
        )

      })

    )

  }
  else {
    return (
      <Card key={"card"} className="p-4 mt-4">
        <div className="row border-bottom mb-2 pb-2">
          <div className="col-2 d-none d-md-block">Label</div>
          <div className="col-6 col-md-5">New value</div>
          <div className="col-6 col-md-5">Original value</div>
        </div>

        {Object.keys(data).map(key => {
          let highlightInfo = false;
          if (appdata.activeRequestType != "NV") {
            if (data[key].active != data[key].sap) {
              highlightInfo = true;
            }
          }
          return (
            <div className={(highlightInfo) ? "border border-info row mt-1 mb-1" : "row mt-1 mb-1"} key={"rowpart" + key}>
              <div className="col-2 d-none d-md-block">
                <b>{data[key].label}</b>
              </div>
              <div className="col-6 col-md-5">{data[key].active}</div>
              <div className="col-6 col-md-5" style={{ textDecoration: highlightInfo ? "line-through" : "" }}>{data[key].sap}</div>
            </div>
          );
        })}

      </Card>
    )
  }
}

export default VendordataNonEditablePart;
